<template>
    <div>
		<a-row class="">
			<div class="flex mt15 mb15" style="justify-content: space-between;">
                <div class="flex items-center">
                    <img class="ml15 mr10" src="../../../public/images/guigeguanli.png" style="width:25px;height:25px" />
                    <div class="ml0 fs14" style="color:grey">材料库存表</div>
                    <a @click="goTransportRecord" class="ml30 fs12">物资调运记录</a>
                </div>
                <div class="mr20 flex" style=""> 
                    <a-select
                        show-search
                        v-model="select_project_id"
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        style="width: 300px"
                        placeholder="请选择项目"
                        @change=""
                        size="small"
                    > 
                    <a-select-option v-for="item in projectList" :key="item.id" :value="item.id">
                        {{ item.name }}
                        </a-select-option>
                    </a-select>
                    <a-input-search class="ml10" size="small" allowClear v-model="search" placeholder="请输入关键字" enter-button @change="allowCostClear" @search="onSearch" @pressEnter="onSearch"/>
                    <!-- <a-button class="ml10" style="background-color: #fd6363;color: white;" icon="sync" @click="">
                        导出
                    </a-button> -->
                </div>
            </div>
		</a-row>
        <a-row :gutter="24" type="flex" align="stretch">
            <a-col :span="24" :lg="30" class="mb-24">
				<a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0,}">
                    <div class="h100" style="overflow: auto;">
                        <div class="mt20">
                            <a-table :columns="inventoryColumns" :data-source="inventoryData" size="small" :pagination="false">
                                <template slot="current_count" slot-scope="text,record">
                                    <div style="color:red" v-if="record.current_count <= record.warning_value">{{ record.current_count }}  (库存不足)</div>  
                                    <a v-else>{{ record.current_count }}</a>                       
                                </template>
                                <template slot="ope" slot-scope="text,record">
                                    <a class="fs12" @click="addTransport(record)">物资调运</a>  
                                </template>
                            </a-table>
                            <a-pagination 
                                class="flex items-center mb10"
                                style="justify-content: flex-end"
                                show-quick-jumper  
                                v-model="page.page" 
                                :total="page.total" 
                                :page-size="30"
                                @change="getMaterialInventory" 
                            />
                        </div>
                    </div>
                </a-card>
            </a-col>
        </a-row>
        <a-modal
            title="新增物资调运·默认业务类型"
            width="95vw"
            :visible="visibleAddPlan"
            @close="visibleAddPlan = false"
            @cancel="visibleAddPlan = false"
        >
            <CardTransportAdd ref="son" :material="transport_material"></CardTransportAdd>
            <div
                :style="{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                    width: '100%',
                    borderTop: '1px solid #e9e9e9',
                    padding: '10px 16px',
                    background: '#fff',
                    textAlign: 'right',
                    zIndex: 1,
                }"
            >
                <a-button :style="{ marginRight: '8px' }" @click="visibleAddPlan = false">
                    取消
                </a-button>
                <a-button type="danger" @click="goAddTransport">
                    提交
                </a-button>
            </div>
        </a-modal>
    </div> 
</template>

<script>
import CardTransportAdd from "../../components/Cards/CardTransportAdd.vue";
const KF = 'updatable';

	export default ({
		components: {
            CardTransportAdd
        },
        directives: { 

        },
		data() {
			return {
                inventoryColumns: [
                    { title: 'ID', dataIndex: 'key', width: 50 },
                    { title: '项目名称', dataIndex: 'project_name' },
                    { title: '物资名称', dataIndex: 'name' },
                    { title: '品牌', dataIndex: 'brand' },
                    { title: '规格型号', dataIndex: 'size', ellipsis: true,},
                    { title: '单位', dataIndex: 'unit' },
                    { title: '库存', dataIndex: 'current_count', scopedSlots: { customRender: 'current_count' }},
                    { title: '操作', scopedSlots: { customRender: 'ope' }, width: 160 },
                ],
                inventoryData: [],
                search:"",
                page:{page:1, total:0},
                projectList:[],
                select_project_id:-1,
                visibleAddPlan:false,
                transport_material:[],
			}
		},
		async created() {
            this.getMaterialInventory()
            this.getProjectList()
		},
		methods:{
            async getMaterialInventory() {
                let rs = await this.$api.getMaterialInventory(this.search, this.page.page -1 , 30);
                if (rs.err == 0) {
                    let ca = (this.page.page - 1) * 30 + 1
                    for (let item of rs.data) {
                        item.key = ca;
                        ca ++
                    }
                    this.inventoryData = rs.data;
                    this.page.total = rs.count
                }
            },
            onSearch(){
                this.page.page = 1
                this.getMaterialInventory()
            },
            allowCostClear(){
                if(this.search.length == 0){
                    this.page.page = 1;
                    this.getMaterialInventory()
                }
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            async getProjectList(){
                let rs = await this.$api.getProjectList()
                if(rs.err == 0){
                    this.projectList = rs.data
                    this.projectList.push({id:-1, name:"全部"})
                }
            },
            goTransportRecord(){
                this.$router.push("/purchase/transport")
            },
            addTransport(record){
                this.transport_material = record
                this.visibleAddPlan = true
                this.$nextTick(()=>{
                    this.$refs.son.addTransport()
                })
            },
            async goAddTransport(){
                var newTransport = this.$refs.son.newTransport
                let rs = await this.$api.getTransportApprovalList(newTransport.data.project_id, newTransport.data.to_project_id)
                if(rs.err == 0){
                    newTransport.flowdata = []
                    let a1 = {flow_type:1, persons:[]}

                    let bs = {flow_type:2, persons:[]}

                    for(let item of rs.data){
                        a1.persons.push(item.uid)
                    }
                    newTransport.flowdata.push(a1)
                    for(let item of rs.toProject){
                        let a2 = {flow_type:1, persons:[]}
                        a2.persons.push(item.uid)
                        newTransport.flowdata.push(a2)
                    }
                    for(let item of rs.fromProject){
                        let a3 = {flow_type:1, persons:[]}
                        a3.persons.push(item.uid)
                        newTransport.flowdata.push(a3)
                    }
                    newTransport.flowdata.push(bs)
                    // this.newTransport.flowdata = [{flow_type:1, persons:[]},{flow_type:1, persons:[]},{flow_type:1, persons:[]}, {flow_type:2, zs:[]}]

                }
                let ps = await this.$api.goAddTransport(newTransport)
                if(ps.err == 0){
                    this.$message.success('保存成功')
                    this.visibleAddPlan = false
                }else{
                    this.$message.warn('保存失败，请检查后重试或联系管理员')
                }
            },
		}
	})
</script>

<style>

</style>